import React from "react"
import clsx from "clsx"
import numeral from "numeral"
import ApplyToAllButton from "../ApplyToAllButton/ApplyToAllButton"
import SeasonTypeDataType from "../DataTable/dataTypes/SeasonTypeDataType"
import CurrencyInput from "../CurrencyInput/CurrencyInput"
import NumberInput from "../NumberInput/NumberInput"

class AutoPriceBuilder extends React.Component {

  constructor(props) {
    super(props)

    this.onChange = this.onChange.bind(this);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })

    var days_of_week = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    var days = days_of_week.map((day_of_week) => this.renderDayOfWeek(day_of_week))
    var base_price = days_of_week.map((day_of_week) => this.renderBasePrice(day_of_week))
    var min_stay = days_of_week.map((day_of_week) => this.renderDailyMinimumStay(day_of_week))

    return (
      <div className={tabClasses} id="general">
        <div className="card well-md">
          <div className="row" style={{ marginBottom: 20 }}>
            {this.renderSeasonOrRoomType()}
            {this.renderRemoveButton()}
          </div>
          <div className="container-fluid" style={{ overflowX: "scroll" }}>
            <div className='row' style={{ minWidth: "800px" }}>
              <div className='col-md-2 col-sm-2 col-xs-2' style={{ width: '12%', marginRight: "20px" }}>
                <label style={{ visibility: "hidden" }}>""</label>
              </div>
              {days}
            </div>
            <div className='row' style={{ marginTop: "10px", minWidth: "800px" }}>
              <div className='col-md-2 col-sm-2 col-xs-2' style={{ width: '12%', marginRight: "20px" }}>
                <label>{I18n.t("base_price")}</label>
              </div>
              {base_price}
            </div>
            <div className='row' style={{ marginTop: "10px", minWidth: "800px" }}>
              <div className='col-md-2 col-sm-2 col-xs-2' style={{ width: '12%', marginRight: "20px" }}>
                <label style={{ whiteSpace: 'nowrap' }}>{I18n.t("minimum_stay")}</label>
              </div>
              {min_stay}
            </div>
          </div>
          <ApplyToAllButton onChangeAllDays={this.props.onChangeAllDays} onChangeAllMinimumStays={this.props.onChangeAllMinimumStays} sundayAmount={this.props.sunday_amount} sundayMinimumStay={this.props.sunday_minimum_stay} roomTypeId={this.props.room_type.id} />
        </div>
      </div>
    )
  }

  renderSeasonOrRoomType() {
    if (this.props.view_type == 'room_type_price') {
      return (
        <div>
          <div className="col-md-10">
            <label>{I18n.t('room_type')}</label>
            <div>{this.props.room_type.name}</div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="col-md-2" style={{width: '14.2857%'}}>
            <label>{I18n.t('season')}</label>
            <div>{this.props.season.name}</div>
          </div>
          <div className="col-md-8" style={{width: '68.4285%'}}>
            <label>{I18n.t('season_type')}</label>
            <SeasonTypeDataType date_format={this.props.date_format} row={this.props.season} />
          </div>
        </div>
      );
    }
  }

  renderDayOfWeek(day_of_week) {
    return (
      <div className='col-md-1 col-sm-1 col-xs-1' style={{ width: '12%' }} key={day_of_week}>
        <label>{I18n.t(day_of_week)}</label>
      </div>
    )
  }

  renderDailyMinimumStay(day_of_week) {
    var min_stay_name = day_of_week + '_minimum_stay';
    return (
      <div className='col-md-1 col-sm-1 col-xs-1' style={{ width: '12%' }} key={min_stay_name}>
        <div className={this.renderFieldClasses(min_stay_name, 'input-group')}>
          <NumberInput className="form-control" name={min_stay_name} onChange={this.onChange} value={this.props[min_stay_name]} />
        </div>
        {this.props.room_type_price && this.props.room_type_price[min_stay_name] ? <div className="text-center" style={{marginTop: 5, color: '#777'}}>{this.props.room_type_price[min_stay_name]} {I18n.t('night')} {I18n.t('min_stay')}</div> : null}
        {this.renderFieldErrors(min_stay_name)}
      </div>
    )
  }

  renderBasePrice(day_of_week) {
    var base_price = day_of_week + '_amount';
    return (
      <div className='col-md-1 col-sm-1 col-xs-1' style={{ width: '12%' }} key={base_price}>
        <div className={this.renderFieldClasses(base_price, "input-group input-group-currency")}>
          <div className="input-group-addon">{I18n.t('number.currency.format.unit')}</div>
          <CurrencyInput className="form-control" name={base_price} onChange={this.onChange} value={this.props[base_price]} onChangeEventType={true} nested={true} />
        </div>
        {this.props.room_type_price ? <div className="text-center" style={{marginTop: 5, color: '#777'}}><em>${this.props.room_type_price[base_price] ? numeral(this.props.room_type_price[base_price] / 100).format('0,0.00') : ''}</em></div> : null}
        {this.renderFieldErrors(base_price)}
      </div>
    )
  }

  renderRemoveButton() {
    if (this.props.read_only != true && typeof this.props.onRemove == 'function') {
      return (
        <div className="col-md-2 col-remove" style={{position: 'relative', right: -7}}>
          <button type="button" className="btn btn-secondary pull-right" onClick={this.props.onRemove.bind(this, this.props.id)}>{I18n.t('remove')}</button>
        </div>
      );
    }

    return null;
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;

      });

      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field, classnames) {
    var classname = classnames || 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }

    return classname;
  }

  /*** Change handlers ***/

  onChange(event) {
    if (typeof this.props.onChange == 'function') {
      var seasonal_price = {
        id: this.props.id || '-0',
        season: this.props.season || null,
        season_id: this.props.season_id || (this.props.season ? this.props.season.id : '-0'),
        room_type: this.props.room_type || {},
        room_type_id: this.props.room_type_id || null,
        room_type_price: this.props.room_type_price || null,
        room_type_price_id: this.props.room_type_price_id || '-0',
        sunday_amount: this.props.sunday_amount || '',
        monday_amount: this.props.monday_amount || '',
        tuesday_amount: this.props.tuesday_amount || '',
        wednesday_amount: this.props.wednesday_amount || '',
        thursday_amount: this.props.thursday_amount || '',
        friday_amount: this.props.friday_amount || '',
        saturday_amount: this.props.saturday_amount || '',
        sunday_minimum_stay: this.props.sunday_minimum_stay || '',
        monday_minimum_stay: this.props.monday_minimum_stay || '',
        tuesday_minimum_stay: this.props.tuesday_minimum_stay || '',
        wednesday_minimum_stay: this.props.wednesday_minimum_stay || '',
        thursday_minimum_stay: this.props.thursday_minimum_stay || '',
        friday_minimum_stay: this.props.friday_minimum_stay || '',
        saturday_minimum_stay: this.props.saturday_minimum_stay || '',
      };
      seasonal_price[event.target.name] = event.target.value;

      this.props.onChange(seasonal_price);
    }
  }

};

export default AutoPriceBuilder